export default __webpack_public_path__ + "static/media/0x41b3966b4ff7b427969ddf5da3627d6aeae9a48e.82d066df.png";